/**
 * Resolve desktop absolute summary_folder paths to OneDrive-relative paths
 * under the PaperReader root.
 */
export function toPaperReaderRelative(summaryFolder, paperReaderFolder) {
  if (!summaryFolder || !String(summaryFolder).trim()) return null;
  let raw = String(summaryFolder).trim().replace(/\\/g, "/");

  const markers = [
    "/PaperReader/",
    "/PaperReader",
    "PaperReader/",
  ];
  for (const marker of markers) {
    const idx = raw.indexOf(marker);
    if (idx >= 0) {
      let rest = raw.slice(idx + (marker.endsWith("/") ? marker.length : "PaperReader".length));
      rest = rest.replace(/^\/+/, "");
      if (!rest || rest === "/") return null;
      return rest.replace(/\/+$/, "");
    }
  }

  // Already relative (e.g. "2026-07-05_title_quick-summary")
  if (!raw.includes(":") && !raw.startsWith("/Users/") && !raw.startsWith("/home/")) {
    return raw.replace(/^\/+/, "").replace(/\/+$/, "") || null;
  }

  // Fallback: last path segment as folder name under PaperReader
  const parts = raw.split("/").filter(Boolean);
  const last = parts[parts.length - 1];
  return last || null;
}

export function ozetPath(relativeFolder) {
  if (!relativeFolder) return null;
  const folder = relativeFolder.replace(/\/+$/, "");
  if (folder.toLowerCase().endsWith("ozet.md")) return folder;
  return `${folder}/ozet.md`;
}

export function driveItemPath(paperReaderFolder, relativePath) {
  const root = paperReaderFolder.replace(/^\/+|\/+$/g, "");
  const rel = String(relativePath || "")
    .replace(/^\/+/, "")
    .replace(/\\/g, "/");
  return rel ? `${root}/${rel}` : root;
}
